import { Cubit } from "blac-next";
import {
  createCmsClient,
  type CmsApiClient,
  type FeedRequestBody,
  type JourneyData
} from "@9amhealth/cms-api";
import envVariables from "src/lib/envVariables";
import { getSupportedUserLanguage } from "src/lib/i18next";
import {
  Feed,
  FeedData
} from "src/ui/components/UserEducationalFeed/UserEducationalFeedBloc";

type RemoteConfigState = Record<string, never>;

export class AppRemoteConfigCubit extends Cubit<RemoteConfigState> {
  private client: CmsApiClient;

  constructor() {
    super({});
    this.client = createCmsClient(envVariables.CMS_API_BASE_URL);
  }

  loadJourneyContent = async (
    journey: string,
    params?: {
      language?: string;
    }
  ): Promise<JourneyData> => {
    const { language = getSupportedUserLanguage() } = params || {};

    const response = await this.client.api.educational.program.$get({
      query: {
        language,
        journey
      }
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `CMS API request failed (${response.status}): ${errorText}`
      );
    }

    const responseJson = (await response.json()) as unknown as {
      data: JourneyData;
    };
    return responseJson.data;
  };

  loadEducationalContent = async (
    params: FeedRequestBody
  ): Promise<FeedData> => {
    const body = { json: params };
    const response = await this.client.api.educational.feed.$post(body);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `CMS API request failed (${response.status}): ${errorText}`
      );
    }

    const responseJson = (await response.json()) as unknown as Feed;
    return responseJson.data;
  };
}
